module.exports = __webpack_public_path__ + "img/hermelin_logo.db27cf67.png";